import type { StateCreator } from 'zustand';
import type { ScoreBreakdownType } from '../../lib/types/TeamBehavior';
import type { BehaviorType } from '../../components/TeamBehaviors/enum/BehaviorType';

export const teamBehaviors: StateCreator<TeamBehaviorsStore> = (set) => {
  return {
    selectedBehaviorFilter: undefined,
    setSelectedBehaviorFilter: (name: ScoreBreakdownType, type: BehaviorType) => {
      set({
        selectedBehaviorFilter: {
          name,
          type,
        },
      });
    },
    clearSelectedBehaviorFilter: () => {
      set({ selectedBehaviorFilter: undefined });
    },
  };
};

type TeamBehaviorsStore = {
  selectedBehaviorFilter?: {
    name: ScoreBreakdownType;
    type: BehaviorType;
  };
  setSelectedBehaviorFilter: (name: ScoreBreakdownType, type: BehaviorType) => void;
  clearSelectedBehaviorFilter: () => void;
};
